// src/roleAccess.js
export const NAV_PERMISSIONS = {
  Associate: {
    'Task Management': ['View Tasks'],
  },
  Manager: {
    'Lead Management': ['Manage Leads'],
    'User Management': ['Career Associate-Manager Mappings'],
    'Task Management': ['Scoring Queue Summary'],
    'Job Relevance Scoring': ['Trends Dashboard'],
  },
  // Leave the rest as-is for now; adjust after your confirmation
  Admin: 'ALL',
  'Super Admin': 'ALL',
  'Associate admin': 'ALL_EXCEPT_USER_MANAGEMENT',
  'Associate Admin': 'ALL_EXCEPT_USER_MANAGEMENT',
  User: {
    'Task Management': ['View Tasks'],
  },
};

export function filterNavItemsForRole(allNavItems, role) {
  const rule = NAV_PERMISSIONS[role];
  if (!rule || rule === 'ALL') return allNavItems;
  
  if (rule === 'ALL_EXCEPT_USER_MANAGEMENT') {
    return allNavItems.filter((section) => section.section !== 'User Management');
  }

  return allNavItems
    .map((section) => {
      const allowedLabels = rule[section.section];
      if (!allowedLabels) return null;
      const items = section.items.filter((i) => allowedLabels.includes(i.label));
      if (items.length === 0) return null;
      return { ...section, items };
    })
    .filter(Boolean);
}
